import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { LoginButtonComponent } from './login-button/login-button.component';
import { RegisterButtonComponent } from './register-button/register-button.component';
import { PreregisterButtonComponent } from "./preregister-button/preregister-button.component";
import { RegisterFormComponent } from './register-form/register-form.component';
import { AndroidButtonComponent } from "./android-button/android-button.component";
import { IosButtonComponent } from "./ios-button/ios-button.component";

import {PlatformModule} from "../platform/platform.module";


@NgModule({
  declarations: [LoginButtonComponent, RegisterButtonComponent, PreregisterButtonComponent, RegisterFormComponent, AndroidButtonComponent, IosButtonComponent],
  imports: [
      CommonModule,
      RouterModule,
      PlatformModule
  ],
  exports: [ LoginButtonComponent, RegisterButtonComponent, PreregisterButtonComponent, RegisterFormComponent , AndroidButtonComponent, IosButtonComponent]
})
export class AccountModule { }
